import type {Dayjs} from 'dayjs'

// TODO: Claude 15/09/2026 | validar as janelas tambem no back (POST /agenda-externa) — ver pendencias.md

export interface JanelaEntrega {
  inicio: {hora: number; minuto: number}
  fim: {hora: number; minuto: number}
}

export const JANELAS_ENTREGA: readonly JanelaEntrega[] = [
  {inicio: {hora: 8, minuto: 30}, fim: {hora: 12, minuto: 0}},
  {inicio: {hora: 14, minuto: 0}, fim: {hora: 17, minuto: 0}},
]

export const PASSO_MINUTOS_ENTREGA = 15

const MINUTOS_POR_HORA = 60
const HORAS_DO_DIA = Array.from({length: 24}, (_, hora) => hora)
const MINUTOS_DA_HORA = Array.from({length: MINUTOS_POR_HORA}, (_, minuto) => minuto)

const paraMinutos = ({hora, minuto}: {hora: number; minuto: number}) => hora * MINUTOS_POR_HORA + minuto

const formatarHora = ({hora, minuto}: {hora: number; minuto: number}) =>
  `${String(hora).padStart(2, '0')}:${String(minuto).padStart(2, '0')}`

const isMinutoDoDiaDentroDasJanelas = (minutoDoDia: number) =>
  JANELAS_ENTREGA.some(janela => minutoDoDia >= paraMinutos(janela.inicio) && minutoDoDia <= paraMinutos(janela.fim))

const isHoraComAlgumMinutoValido = (hora: number) =>
  MINUTOS_DA_HORA.some(minuto => isMinutoDoDiaDentroDasJanelas(paraMinutos({hora, minuto})))

export const descreverJanelasEntrega = () =>
  JANELAS_ENTREGA.map(janela => `${formatarHora(janela.inicio)}–${formatarHora(janela.fim)}`).join(' e ')

export const DICA_JANELAS_ENTREGA = `A filial recebe das ${JANELAS_ENTREGA.map(janela => `${formatarHora(janela.inicio)} às ${formatarHora(janela.fim)}`).join(' e das ')}.`

export const MENSAGEM_HORARIO_FORA_DAS_JANELAS = `Horário fora das janelas de recebimento: ${descreverJanelasEntrega()}`

export const isHorarioDentroDasJanelas = (horario: Dayjs) =>
  isMinutoDoDiaDentroDasJanelas(paraMinutos({hora: horario.hour(), minuto: horario.minute()}))

export const resolverHorasEMinutosDesabilitados = () => ({
  disabledHours: () => HORAS_DO_DIA.filter(hora => !isHoraComAlgumMinutoValido(hora)),
  disabledMinutes: (horaSelecionada: number) =>
    MINUTOS_DA_HORA.filter(minuto => !isMinutoDoDiaDentroDasJanelas(paraMinutos({hora: horaSelecionada, minuto}))),
})

export const validarHorarioEntrega = (_: unknown, horario: Dayjs | null | undefined) => {
  const isHorarioVazio = !horario
  const isHorarioPermitido = isHorarioVazio || isHorarioDentroDasJanelas(horario)
  return isHorarioPermitido ? Promise.resolve() : Promise.reject(new Error(MENSAGEM_HORARIO_FORA_DAS_JANELAS))
}
